import { render, staticRenderFns } from "./CalendarMilestoneDetailDialog.vue?vue&type=template&id=94340be0&"
import script from "./CalendarMilestoneDetailDialog.vue?vue&type=script&lang=js&"
export * from "./CalendarMilestoneDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports